import { TimelineMax, Expo } from 'gsap';

import hades from '@/scripts/hades';

export function nextIn2(el, done) {
  const tl = new TimelineMax({
    onComplete: done,
  });

  tl
    .set(el, {
      autoAlpha: 1,
    });

  return tl;
}

export function nextOut2(el, done) {
  const tl = new TimelineMax({
    onComplete: () => {
      hades.ref.play();
      done();
    },
  });
  const item = el.querySelector('.hero__next');
  const bg = el.querySelector('.hero__bg__image');
  const bgNext = el.querySelector('.hero__next__image');
  const title = el.querySelector('.hero__title');

  tl
    .add('start')
    .set(bgNext, {
      scale: 1.2,
    })
    .set(el, {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100vw',
      zIndex: 10,
    }, 'start')
    .to(item, 1.8, {
      left: '50%',
      x: 0,
      xPercent: '-50%',
      opacity: 1,
      ease: Expo.easeInOut,
    }, 'start')
    .to(bg, 1.6, {
      autoAlpha: 0,
      ease: Expo.easeOut,
    }, 'start+=0.8')
    .to(bgNext, 1.6, {
      scale: 1,
      autoAlpha: 1,
      ease: Expo.easeOut,
    }, 'start+=1')
    .to(title, 1, {
      autoAlpha: 0,
      ease: Expo.easeOut,
    }, 'start');

  return tl;
}
